import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';

import { Text, StyledCard, StyledCardContent, Tag, RadarChartCard, Avatar } from '../../index';

import { SESSION_COLORS, SESSION_TYPE } from '../../../constant';

dayjs.extend(objectSupport);

export const InfoCard = ({ meet }) => {
    return (
        <StyledCard>
            <StyledCardContent style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                    <Tag $backgroundColor={SESSION_COLORS[meet.type]}>
                        <Text $fontSize="10px" $color="white">
                            {SESSION_TYPE[meet.type]}
                        </Text>
                    </Tag>
                    <Text $bold $fontSize="18px">
                        {meet?.name}
                    </Text>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                    <Text $fontSize="14px">Date/Time:</Text>
                    <Text $fontSize="12px" $color="gray1">
                        {!_.isEmpty(meet) &&
                            `${dayjs(meet.startDate).format('ddd, DD MMM YYYY')}, ${dayjs()
                                .set({
                                    hour: meet.startTime.split(':')[0],
                                    minute: meet.startTime.split(':')[1],
                                })
                                .format('HH:mm')} - ${dayjs()
                                .set({
                                    hour: meet.endTime.split(':')[0],
                                    minute: meet.endTime.split(':')[1],
                                })
                                .format('HH:mm')}`}
                    </Text>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                    <Text $fontSize="14px">Participant:</Text>
                    <Text $fontSize="14px" $color="gray1">
                        {!_.isEmpty(meet.patients) &&
                            meet.patients.map((p, index, arr) =>
                                arr.length - 1 === index
                                    ? p?.user?.fullname
                                    : p?.user?.fullname + ', '
                            )}
                    </Text>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

InfoCard.propTypes = {
    meet: PropTypes.object,
};

export const PatientsEmotional = ({ data, selectedPatient, setSelectedPatient }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '20px' }}>
            <Text $bold $fontSize="18px">
                Client Emotional Chart ({data.length})
            </Text>
            <div
                style={{
                    display: 'grid',
                    rowGap: '20px',
                    columnGap: '20px',
                    gridTemplateColumns: 'repeat(3,1fr)',
                }}
            >
                {data.map((item) => (
                    <RadarChartCard
                        data={item}
                        key={item.patient.id}
                        selected={item.patient.id === selectedPatient}
                        onClick={() => setSelectedPatient(item.patient.id)}
                    />
                ))}
            </div>
        </div>
    );
};

PatientsEmotional.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    selectedPatient: PropTypes.string,
    setSelectedPatient: PropTypes.func.isRequired,
};

export const SessionNotesCard = ({ data, isGroup }) => {
    return (
        <StyledCard>
            <StyledCardContent>
                <Text $fontSize="20px" $bold>
                    Session Notes
                </Text>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '20px',
                        marginTop: '20px',
                    }}
                >
                    {data.map((item) => (
                        <div
                            key={item.id}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: '5px',
                            }}
                        >
                            <div style={{ display: 'flex', columnGap: '15px' }}>
                                <Text $color="gray2" $fontSize="12px">
                                    {dayjs(item.createdAt).format('HH:mm')}
                                </Text>
                                {isGroup && (
                                    <Text $color="gray2" $fontSize="12px">
                                        {item.patient ? item.patient?.user?.fullname : 'Note'}
                                    </Text>
                                )}
                            </div>
                            {item.description && <Text $fontSize="14px">{item.description}</Text>}
                            {!_.isEmpty(item.emotions) && (
                                <div
                                    style={{
                                        display: 'flex',
                                        columnGap: '5px',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Text $color="gray2" $fontSize="12px">
                                        Emotion:
                                    </Text>
                                    {item.emotions.map((e) => (
                                        <Text
                                            $color="gray2"
                                            $fontSize="12px"
                                            key={`${item.id}-emotion-${e.id}`}
                                            style={{ textTransform: 'capitalize' }}
                                        >
                                            {e.strEmotion}
                                        </Text>
                                    ))}
                                </div>
                            )}
                            {!_.isEmpty(item.provider_tags) && (
                                <div
                                    style={{
                                        display: 'flex',
                                        columnGap: '5px',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Text $color="gray2" $fontSize="12px">
                                        Tag:
                                    </Text>
                                    {item.provider_tags.map((tag) => (
                                        <Text
                                            $color="gray2"
                                            $fontSize="12px"
                                            key={`${item.id}-tag-${tag.id}`}
                                        >
                                            {tag.name}
                                        </Text>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

SessionNotesCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    isGroup: PropTypes.bool,
};

export const TranscribeCard = ({ data }) => {
    return (
        <StyledCard>
            <StyledCardContent>
                <Text $fontSize="20px" $bold>
                    Transcribe
                </Text>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '20px',
                        marginTop: '20px',
                    }}
                >
                    {/* {data?.status === 'BEGIN_TRANSCRIBE' && (
                        <Text $fontSize="16px">In progress. Please come back later.</Text>
                    )}
                    {data?.status === 'FAIL' && <Text $fontSize="16px">Transcribe failed.</Text>}
                    {data?.status === 'SUCCESS' && _.isEmpty(data?.record) && (
                        <Text $fontSize="16px">No transcribe found.</Text>
                    )}

                    {data?.status === 'SUCCESS' &&
                        !_.isEmpty(data?.record) &&
                        data?.record.map((item, index) => (
                            <div
                                key={`transcribe-${index}`}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    columnGap: '15px',
                                }}
                            >
                                <Avatar
                                    $avatarSize="54px"
                                    $borderRadius="50%"
                                    src={item.user?.avatar?.url}
                                    alt={item.user?.fullname}
                                />

                                <div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            columnGap: '15px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Text $bold $fontSize="14px" $color="gray2">
                                            {item.user?.fullname}
                                        </Text>
                                        <Text $fontSize="12px" $color="gray14">
                                            {item.startAt}
                                        </Text>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            rowGap: '10px',
                                        }}
                                    >
                                        {item.texts.map((text, textIndex) => (
                                            <Text key={`text-${index}-${textIndex}`}>{text}</Text>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))} */}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

TranscribeCard.propTypes = {
    data: PropTypes.object,
};
